import Drawer from "@mui/material/Drawer";
import { Box, Grid } from "@mui/material";

function SideDrawer({ children, isOpen, setIsOpen }) {
  return (
    <Box>
      <Drawer anchor="right" open={isOpen} onClose={() => setIsOpen(false)}>
        <Grid sx={{ width: 400, height: "100%" }}>{children}</Grid>
      </Drawer>
    </Box>
  );
}

export default SideDrawer;
